import { UncontrolledTooltip } from 'reactstrap';
import {
  IconButton,
  BlackDeleteIcon as blackDeleteIcon,
  BlackUndoIcon as blackUndoIcon,
} from '@/shared/ui';
import { EventThumbnailConfig } from '@/entities/ecg';
import BookmarkPaginationContainer from './bookmarkPaginationContainer';
import useBookmarkButtonTypes from './useBookmarkButtonTypes';

/**
 * Renders the toolbar above the ECG bookmark strip list with its delete and reset controls. Disables both icon buttons while useBookmarkButtonTypes reports nothing actionable, reveals the reset button only when unapplied bookmark changes exist, and hosts the thumbnail config and bookmark pagination alongside them.
 *
 * @returns The bookmark toolbar with its delete and reset buttons, thumbnail config and pagination.
 */
const BookmarkButtonTypes = () => {
  const { isDisableButton, isShowResetButton, handleDeleteBookmark, handleResetBookmark } =
    useBookmarkButtonTypes();

  return (
    <div id="button-types" className="rhythm-event-content-top-container --min-width-strip-event">
      <div className="toolbar">
        <IconButton
          id="btnDeleteBookmark"
          isOutline
          iconComponent={<img src={blackDeleteIcon} alt="Delete icon" />}
          disabled={isDisableButton}
          onClick={() => {
            handleDeleteBookmark();
          }}
        />
        <UncontrolledTooltip
          className="custom-tooltip"
          target="btnDeleteBookmark"
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          hideArrow
        >
          <div className="beat-tooltip">
            Delete bookmark
            <span className="shortkey">D</span>
          </div>
        </UncontrolledTooltip>
        {isShowResetButton && (
          <>
            <div className="btn-type-vertical-line" />
            <IconButton
              id="btnResetBookmark"
              isOutline
              iconComponent={<img src={blackUndoIcon} alt="Noise icon" />}
              disabled={isDisableButton}
              onClick={handleResetBookmark}
            />
            <UncontrolledTooltip
              className="custom-tooltip"
              target="btnResetBookmark"
              placement="bottom"
              delay={{ show: 0, hide: 0 }}
              hideArrow
            >
              <div className="beat-tooltip">Reset changes</div>
            </UncontrolledTooltip>
          </>
        )}
      </div>
      <EventThumbnailConfig />
      <div className="toolbar-container">
        <BookmarkPaginationContainer />
      </div>
    </div>
  );
};

export default BookmarkButtonTypes;
